import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTABand = ({ title = "Healing through story. Strength through connection.", text, primary, secondary }) => (
  <section className="px-6 py-20 sm:py-28 bg-cream">
    <Reveal>
      <div className="relative overflow-hidden max-w-6xl mx-auto rounded-[48px] bg-charcoal text-cream px-8 py-16 sm:p-20 grain">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-terracotta/40 organic-blob blur-3xl" />
        <div className="absolute -bottom-24 -left-16 w-72 h-72 bg-ochre/25 organic-blob-alt blur-3xl" />
        <div className="relative">
          <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-3xl">{title}</h2>
          {text && <p className="mt-6 text-cream/80 max-w-xl leading-relaxed">{text}</p>}
          <div className="mt-10 flex flex-wrap gap-4">
            {primary && (
              <Link
                data-testid="cta-band-primary-btn"
                to={primary.to}
                className="group inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 text-sm font-bold uppercase tracking-widest text-cream transition-transform duration-300 hover:scale-105"
              >
                {primary.label}
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            )}
            {secondary && (
              <Link
                data-testid="cta-band-secondary-btn"
                to={secondary.to}
                className="inline-flex items-center gap-2 rounded-full border border-cream/40 px-8 py-4 text-sm font-bold uppercase tracking-widest text-cream transition-colors duration-300 hover:bg-cream/10"
              >
                {secondary.label}
              </Link>
            )}
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
